import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=14ca84c3&scoped=true"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ca84c3",
  null
  
)

export default component.exports